module.exports = "/images/Go-Karts.svg?ef9a24ff8e37a3bcb8ff402bff6a2153";